import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {withRouter} from 'react-router'

import {fetchBanners} from 'mb-app-common/lib/api/banners'

class ServerBanner extends PureComponent{
	static propTypes = {
		location: PropTypes.shape({
			pathname: PropTypes.string.isRequired
		}).isRequired
	}

	state = {
		banners: []
	}

	componentWillMount(){
		fetchBanners().then((banners) => this.setState({
			banners: banners
		}))
	}

	render(){
		return (
			<div>
				{
					this.state.banners.filter(({urlPath}) =>
						new RegExp(urlPath.substring(1, urlPath.length -1)).test(this.props.location.pathname)
					).map(({type, content}) => (
						<div className={`alert alert-${type}`} role="alert" key={content} dangerouslySetInnerHTML={{__html: content}} />
					))}
			</div>
		)
	}
}

export default withRouter(ServerBanner)



// WEBPACK FOOTER //
// ./client/components/layout/ServerBanner/index.js